import { Component, Input, ViewChild } from '@angular/core';
import { ChangelogMqReport } from '../../interfaces/changelog-mq-report.interface';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ReportService } from 'src/app/dashboard/shared/services/report.service';
import { ChangelogSTMReport } from '../../interfaces/changelog-stm-report';

@Component({
  selector: 'avs-changelog-stm-report',
  standalone: false,
  templateUrl: './changelog-stm-report.component.html',
  styleUrl: './changelog-stm-report.component.css'
})

export class ChangelogStmReportComponent {
  displayedColumns: string[] = ['lineDescription', 'deviceName', 'measuredAt', 'digitalInputActive1', 'digitalInputActive2', 'digitalInputActive3', 'digitalInputActive4', 'digitalOutputActive1', 'duration'];

  dataSource?: MatTableDataSource<ChangelogSTMReport>;
  @Input() changelogs: ChangelogSTMReport[] = [];
  limitedChangelogs: ChangelogSTMReport[] = []
  public rowQuantity: number = 50;
  public rowRange: { start: number, end: number } = { start: 0, end: 50 };

  @Input() digitalInput1Name: string = '';
  @Input() digitalInput2Name: string = '';
  @Input() digitalInput3Name: string = '';
  @Input() digitalInput4Name: string = '';
  @Input() digitalOutput1Name: string = '';

  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;
  public ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.changelogs);
    if (this.paginator)
      this.dataSource!.paginator = this.paginator;
    if (this.sort)
      this.dataSource!.sort = this.sort;
  }

  public onRowQuantityChanged(newValue: number): void {
    this.rowRange.end = this.rowRange.end + newValue - this.rowQuantity;
    this.rowQuantity = newValue;
    this.limitRows();
  }

  public onLeftIconClicked(): void {
    if (this.rowRange.start > this.rowQuantity) {
      this.rowRange.start = this.rowRange.start - this.rowQuantity;
      this.rowRange.end = this.rowRange.end - this.rowQuantity;
    } else {
      this.rowRange.start = 0;
      this.rowRange.end = this.rowQuantity;
    }
    this.limitRows();
  }

  public onRightIconClicked(): void {
    if (this.rowRange.end + this.rowQuantity <= this.changelogs.length) {
      this.rowRange.start = this.rowRange.start + this.rowQuantity;
      this.rowRange.end = this.rowRange.end + this.rowQuantity;
    } else {
      this.rowRange.end = this.changelogs.length;
      this.rowRange.start = this.changelogs.length - this.rowQuantity;
    }
    this.limitRows();
  }

  public onDoubleLeftIconClicked(): void {
    this.rowRange.start = 0;
    this.rowRange.end = this.rowQuantity;
    this.limitRows();
  }

  public onDoubleRightIconClicked(): void {
    this.rowRange.start = this.changelogs.length - this.rowQuantity;
    this.rowRange.end = this.changelogs.length;
    this.limitRows();
  }

  private limitRows(): void {
    this.changelogs = !this.changelogs ? [] : this.changelogs;
    this.limitedChangelogs = this.changelogs.slice(this.rowRange.start, this.rowRange.start + this.rowQuantity);
  }


  lastSunday(year: number, month: number) {
    let date = new Date(year, month, 1, 12);
    let weekday = date.getDay();
    let dayDiff = weekday === 0 ? 7 : weekday;
    let lastSunday = date.setDate(date.getDate() - dayDiff);

    return date;
  }

  isCEST(d: Date): boolean {
    let testD = new Date(d);
    let year = testD.getFullYear();
    let startCET: Date = this.lastSunday(year, 3);
    let endCET: Date = this.lastSunday(year, 10);
    return !(startCET < testD && testD > endCET);
  }

  offset(d: Date): string {
    return this.isCEST(d) ? 'UTC+2' : 'UTC+1'
  }
}
